var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHideEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:rgba(83,86,90,0.49);}.b{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 15,
    cy: 15,
    r: 15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.5 5.252)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14.354,16.577A7.641,7.641,0,0,1,9.846,18.14c-5.311,0-8.346-6.07-8.346-6.07A14,14,0,0,1,5.339,7.563M8.253,6.182A6.92,6.92,0,0,1,9.846,6c5.311,0,8.346,6.07,8.346,6.07a14.037,14.037,0,0,1-1.639,2.42m-5.1-.812a2.276,2.276,0,1,1-3.217-3.217",
    transform: "translate(0 -2.224)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.5,1.5,18.193,18.193",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideEye);
export default __webpack_public_path__ + "static/media/hideEye.544b3cb874ae14a5b32180b73e999e8b.svg";
export { ForwardRef as ReactComponent };